import ApplicationController from './application'

export default class extends ApplicationController {
  static targets = ['free', 'list', 'freeField', 'listField']

  toggle(event) {
    const list = event.target.value === 'list'
    const hideField = list ? this.freeFieldTarget : this.listFieldTarget
    const showField = list ? this.listFieldTarget : this.freeFieldTarget

    this.freeTarget.classList.toggle('hidden', list)
    this.listTarget.classList.toggle('hidden', !list)
    hideField.disabled = true
    showField.disabled = false
    showField.focus()

    // Clearing an active filter must refresh the list.
    if (hideField.value) {
      hideField.value = ''
      this.element.closest('form').requestSubmit()
    }
  }
}
